import {create} from 'zustand';
import {IUserInfo} from './global.service';
import globalStore from './global.state';

type GlobalStore = {
  userInfo: IUserInfo | null;
  token: string | null;
};

type GlobalActions = {
  updateToken: (token: string | null) => void;
  setUserInfo: (userInfo: IUserInfo | null) => void;
};

export const useGlobalStore = create<GlobalStore & GlobalActions>(set => ({
  userInfo: null,
  token: null,
  updateToken: token => {
    globalStore.token = token;
    set({token});
  },
  setUserInfo: userInfo => {
    globalStore.userInfo = userInfo;
    set({userInfo});
  },
}));

export function useLogin() {
  const token = useToken();
  return !!token;
}

export function useToken() {
  const token = useGlobalStore(state => {
    if (state.token) {
      return state.token;
    }
    const _token = localStorage.getItem('token');
    if (_token) {
      globalStore.token = _token;
      return _token;
    }
    return null;
  });

  return token;
}

export function useUserInfo() {
  const userInfo = useGlobalStore(state => {
    if (!state.token) {
      return null;
    }
    if (state.userInfo) {
      return state.userInfo;
    }
    const _userInfoJson = localStorage.getItem('userInfo');
    if (_userInfoJson) {
      try {
        const _userInfo = JSON.parse(_userInfoJson);
        state.setUserInfo(_userInfo);
        return _userInfo;
      } catch (e) {
        console.log('get userinfo error', e);
        return null;
      }
    }
    return null;
  });
  return userInfo;
}
